<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                        <b-tabs pills>
                            <b-tab title="ЭКСПЕРТ2 СТАНДАРТ ТАЛАБЛАРИ" active>
                                <Expert2FieldReferenceList />
                            </b-tab>
                            <b-tab title="ЭКСПЕРТ2 ИЖАРА ТАШКИЛОТЛАРИ" active>
                                <Expert2OrganizationList />
                            </b-tab>
                        </b-tabs>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import bTabs from 'bootstrap-vue/es/components/tabs/tabs';
    import bTab from 'bootstrap-vue/es/components/tabs/tab';

    import Expert2FieldReferenceList from '@/views/config/expert2/Expert2FieldReferenceList'
    import Expert2OrganizationList from "@/views/config/expert2/Expert2OrganizationList.vue";

    export default {
        name: "Expert2Config",
        components: {
            'b-tabs': bTabs,
            'b-tab': bTab,
            Expert2FieldReferenceList,
            Expert2OrganizationList
        }
    }
</script>

<style scoped>

</style>